export class ViewTotal {
    TotalPlannerTask: number;
      TotalEvents: number;
      TotalSSO: number;
      TotalTODOS: number;
      TotalMeeting:number;
      TotalFlaggedEmail:number;
      TotalRecentFiles: number;
      TotalMSList:Number;
      constructor() {
        this.TotalPlannerTask=-1;
        this.TotalEvents=-1;
        this.TotalSSO=-1;
        this.TotalTODOS=-1;
        this.TotalMeeting=-1;
        this.TotalFlaggedEmail=-1;
        this.TotalRecentFiles=-1;
        this.TotalMSList=-1;
      }
}